"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeITxBuildProposalProcedure = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
var ScriptWithRedeemer_1 = require("./ScriptWithRedeemer.js");
function normalizeITxBuildProposalProcedure(_a) {
    var proposalProcedure = _a.proposalProcedure, script = _a.script;
    return {
        proposalProcedure: new cardano_ledger_ts_1.ProposalProcedure(proposalProcedure),
        script: script === undefined ? undefined : (0, ScriptWithRedeemer_1.normalizeIScriptWithRedeemer)(script)
    };
}
exports.normalizeITxBuildProposalProcedure = normalizeITxBuildProposalProcedure;
